import BlankItem from '@components/blank/BlankItem';
import Loading from '@components/Loading';
import styled from '@emotion/styled';
import { Fragment, useContext } from 'react';

import useItems from './hooks/useItems';
import Item from './Item';
import ShopItemContext from '../../context/ShopItemContext';

interface Props {
    columns: number;
}

function ItemGrid({ columns }:Props) {
    const { shopId } = useContext(ShopItemContext);
    const { items, isLoading, isBlank } = useItems();
    return (
        <Fragment>
            {isBlank && (<BlankItem/>)}
            {isLoading && (<Loading size='small'/>)}
            <Container columns={columns}>
                {items?.map((item) => (
                    <Item item={item} shopId={shopId} key={item.id} />
                ))}
            </Container>
        </Fragment>
    );
}

const Container = styled.section<{
    columns: number;
}>`
    display: grid;
    padding: 26px 20px 80px;
    width: 100%;
    overflow: hidden;
    gap: ${({ columns }) => (columns === 2
        ? '16px 24px' : '32px 16px')};
    grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
`;

export default ItemGrid;
